import { Link } from 'react-router-dom';

const stats = [
  { value: '9', label: '在更专题合集' },
  { value: '300+', label: '收录条目' },
  { value: '3', label: '分类榜单' },
  { value: '每日', label: '两次更新' },
];

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-foreground-950" aria-label="首屏品牌介绍">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20abstract%20editorial%20background%20with%20deep%20crimson%20and%20golden%20amber%20light%20streaks%20over%20dark%20warm%20charcoal%20texture%2C%20cinematic%20soft%20shadows%2C%20minimal%20geometric%20paper%20layers%2C%20magazine%20cover%20aesthetic%2C%20no%20text&width=1600&height=900&seq=hl-hero-01&orientation=landscape"
          alt="黑料社网专题盘点门户首屏背景"
          title="黑料社网 专题合集与精选盘点"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative px-4 md:px-10 py-20 md:py-28">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/40 text-accent-300 text-xs tracking-widest">
            <i className="ri-fire-fill"></i>
            专题合集 · 精选盘点 · 分类榜单
          </span>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-black leading-[1.15] text-background-50">
            黑料社网
            <span className="block mt-3 text-xl md:text-3xl lg:text-4xl font-bold text-accent-400">
              精选盘点分类榜单，一次性看够
            </span>
          </h1>

          <p className="mt-6 text-sm md:text-base leading-relaxed text-background-200 max-w-2xl">
            我们把网络热点、娱乐话题、流行梗与名场面，按主题整理成一个个专题合集，再配上分类榜单。
            不用逐个查找，进一个专题就能把同类内容一次看完。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-layout-grid-line"></i>
              浏览全部专题
            </Link>
            <Link
              to="/rankings"
              className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md border border-background-100/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-bar-chart-2-line"></i>
              查看榜单盘点
            </Link>
          </div>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-px bg-background-100/20 rounded-lg overflow-hidden border border-background-100/20">
          {stats.map((s) => (
            <div key={s.label} className="bg-foreground-950/40 backdrop-blur px-6 py-6">
              <div className="font-heading text-2xl md:text-3xl font-black text-accent-400">{s.value}</div>
              <div className="mt-2 text-xs md:text-sm text-background-200">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}